// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  width: 100%;
}

th {
  font-weight: 700;
}

.entitie-list-table-wrapper {
  overflow: auto;
}
.entitie-list-table-wrapper th {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/table-dynamic/table-dynamic.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AAEE;EACE,cAAA;AACJ;AACI;EACE,eAAA;AACN","sourcesContent":["table {\n    width: 100%;\n  }\n\n  th {\n    font-weight: 700;\n  }\n\n  .entitie-list-table-wrapper {\n    overflow: auto;\n\n    th {\n      cursor: pointer;\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
